export const checkAuthorization = async () => {
    const TOKEN = localStorage.getItem('INX.TOKEN') || '';
    if (TOKEN) {
        return [true, null];
    }
    return [false, null];
};

export const removeAuthorization = () => {
    localStorage.clear();
};
